import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ReactiveFormsModule } from "@angular/forms";

import { TranslateModule } from "@ngx-translate/core";

import { AuthRoutingModule } from "./auth-routing.module";
import { LoginComponent } from "./components/login/login.component";
import { PipesModule } from '@shared/pipes';

import { ConfirmDialogModule } from "@shared/confirm-dialog/confirm-dialog.module";
import {MatButtonModule} from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from "@angular/material/input";
import { MatCardModule } from "@angular/material/card";
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';






/**p-table imports */
import {TableModule} from 'primeng/table';
import {CalendarModule} from 'primeng/calendar';
import {SliderModule} from 'primeng/slider';
import {DialogModule} from 'primeng/dialog';
import {MultiSelectModule} from 'primeng/multiselect';
import {ContextMenuModule} from 'primeng/contextmenu';
import {ButtonModule} from 'primeng/button';
import {ToastModule} from 'primeng/toast';
import {InputTextModule} from 'primeng/inputtext';
import {ProgressBarModule} from 'primeng/progressbar';
import {DropdownModule} from 'primeng/dropdown';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { SharedModule } from "@shared/shared.module";
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    AuthRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    TranslateModule,
    ConfirmDialogModule,
    PipesModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatCardModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,


     //**   p-table imports*/
     TableModule,
     CalendarModule,
     SliderModule,
     DialogModule,
     MultiSelectModule,
     ContextMenuModule,
     DropdownModule,
     ButtonModule,
     ToastModule,
     InputTextModule,
     ProgressBarModule,
  ],
  declarations: [LoginComponent, ForgetPasswordComponent, ResetPasswordComponent, ChangePasswordComponent],
  providers: [],
})
export class AuthModule {}
